module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_gift.fffa7.png";